module.exports = __webpack_public_path__ + "static/img/quancheng_01.f8ff11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quancheng_01.png
// module id = nrzh
// module chunks = 1